import ArrSVG from '@public/icons/btn-arr.svg';
import MobileScrollSVG from '@public/icons/mobile-scroll-back.svg';
import { AnimatePresence, MotionValue, m as motion, useMotionValueEvent } from 'framer-motion';
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useFeedbackBtnOpenedLinksValue } from '@/shared/atoms/feedback-links';
import { useMediaQueryDeviceStateValue } from '@/shared/atoms/media-query-device';
import { Theme } from '@/shared/lib/types';
import { scrollToAnchor } from '@/shared/lib/utils/scrollToAnchor';

interface Props {
    scrollYProgress: MotionValue;
    theme: Theme;
    universal?: boolean;
    onVisibilityChange?: (isVisible: boolean) => void;
}

function ScrollTopButton({ scrollYProgress, theme, universal, onVisibilityChange }: Props) {
    const [isButtonVisible, setIsButtonVisible] = useState(false);
    const device = useMediaQueryDeviceStateValue();
    const isfeedbackLinksOpened = useFeedbackBtnOpenedLinksValue();
    const isDesktop = device === 'desktop';

    useMotionValueEvent(scrollYProgress, 'change', (progress) => {
        setIsButtonVisible(progress > 0);
    });

    React.useEffect(() => {
        onVisibilityChange?.(isButtonVisible);
    }, [isButtonVisible, onVisibilityChange]);

    const showMobileButton = isButtonVisible && !isfeedbackLinksOpened && (universal || !isDesktop);
    const showDesktopButton = !universal && isDesktop && isButtonVisible && !isfeedbackLinksOpened;

    const mobileButton = (
        <AnimatePresence>
            {showMobileButton && (
                <motion.button
                    exit={{ opacity: 0 }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    className={`scroll-back-btn-mobile${universal ? ' universal' : ''} theme-${theme}`}
                    onClick={() => {
                        scrollToAnchor('top');
                    }}
                    aria-label="Наверх"
                >
                    <MobileScrollSVG />
                </motion.button>
            )}
        </AnimatePresence>
    );

    return (
        <>
            <AnimatePresence>
                {showDesktopButton && (
                    <motion.div
                        className="scroll-back-btn-block"
                        exit={{ opacity: 0 }}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                    >
                        <div className="text-xs">Наверх</div>
                        <button
                            className="scroll-back-btn"
                            onClick={() => {
                                scrollToAnchor('top');
                            }}
                            aria-label="Наверх"
                        >
                            <ArrSVG />
                        </button>
                    </motion.div>
                )}
            </AnimatePresence>

            {typeof document !== 'undefined' ? createPortal(mobileButton, document.body) : mobileButton}
        </>
    );
}

export default ScrollTopButton;
